import React, { useContext, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { PiStarFill, PiStarLight } from "react-icons/pi";
import { HiOutlineAcademicCap, HiOutlineCheckCircle, HiOutlineArrowRight } from "react-icons/hi2";
import { AppContext } from "./context";
import api from "../../../../../services/api";
import { classNames } from "../../../../../utils";

export default function End() {
  const { workshop, index, userWorkshop, setUserWorkshop, pathId, courseId } = useContext(AppContext);
  const rating = userWorkshop?.feedback_rating || 0;
  const [text, setText] = useState();

  const navigate = useNavigate();

  const handleContinue = async () => {
    if (userWorkshop && userWorkshop._id) {
      const { data } = await api.put(`/workshop_user/${userWorkshop._id}`, { feedback_text: text });
      setUserWorkshop(data);
      toast.success("Feedback submitted!");
    }

    if (courseId) {
      const params = new URLSearchParams();
      if (pathId) params.set("pathId", pathId);
      navigate(`/selecole/course/${courseId}?${params.toString()}`);
    } else {
      navigate("/selecole/learn");
    }
  };

  if (!workshop || index !== workshop.steps.length + 1) return <div />;

  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        {/* Success header */}
        <div className="bg-gradient-to-br from-green-50 to-blue-50 p-8 text-center border-b border-gray-100">
          <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <HiOutlineCheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <div className="text-xs font-bold text-green-600 uppercase tracking-wider mb-2">Workshop Complete</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-1">{workshop.name}</h2>
          <p className="text-sm text-gray-600">{workshop.description}</p>
        </div>

        {/* Feedback section */}
        <div className="p-8 space-y-6">
          {/* Rating */}
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-3">How was this workshop?</p>
            <Rating
              value={rating}
              onChange={async (v) => {
                if (!userWorkshop?._id) return;
                const res = await api.put(`/workshop_user/${userWorkshop._id}`, { feedback_rating: v });
                setUserWorkshop(res.data);
              }}
            />
          </div>

          {/* Comment */}
          <div>
            <label className="text-sm text-gray-600 block mb-2">{workshop.end_question || "Any thoughts to share?"}</label>
            <textarea
              className="w-full h-24 border border-gray-200 rounded-xl p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-shadow"
              placeholder="Share your feedback..."
              value={text || userWorkshop?.feedback_text || ""}
              onChange={(e) => setText(e.target.value)}
            />
          </div>

          {/* Navigation */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
            {courseId ? (
              <button
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md"
                onClick={handleContinue}>
                <HiOutlineAcademicCap className="w-5 h-5" />
                Back to Course
              </button>
            ) : (
              <button
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md"
                onClick={handleContinue}>
                Continue Learning
                <HiOutlineArrowRight className="w-5 h-5" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Rating = ({ value, onChange }) => {
  const [hoveredScore, setHoveredScore] = useState(0);
  const highlightedScore = hoveredScore || value;
  return (
    <div className="flex items-center justify-center gap-1">
      {[1, 2, 3, 4, 5].map((score) => {
        const isShining = score <= highlightedScore;
        return (
          <button
            key={score}
            className={classNames(
              "p-1.5 text-2xl transition-all duration-200 rounded-lg hover:scale-110",
              isShining ? "text-amber-400" : "text-gray-300 hover:text-amber-200"
            )}
            onMouseLeave={() => setHoveredScore(0)}
            onMouseOver={() => setHoveredScore(score)}
            onClick={() => onChange(score)}>
            {isShining ? <PiStarFill /> : <PiStarLight />}
          </button>
        );
      })}
    </div>
  );
};
